import React, { Component } from 'react';
import './App.css';
import View from './View/View.js';

class App extends Component {
  render() {
    return (
      <div className="App">
          <View />
      </div>
    );
  }
}

export default App;
